
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import * as utils from '../Util/util'

const LoaderScreen = ({ showLoadingBar, progress }) => (
  <div className="loader">
    <div className="loader--item">
      <span className="icon-hex-border" />
      <span className="icon-rocket-loading"> </span>
    </div>
    <div className="loader--text">
      <FormattedMessage id="loader.loading" defaultMessage=" " />
      {showLoadingBar && `${progress}%`}
    </div>
    <div className="loader--tip">
      <span className="icon-lightbulb"></span>
      <FormattedMessage id={utils.getRandomTipId()} defaultMessage=" " />
    </div>
  </div>
)

LoaderScreen.propTypes = {
  showLoadingBar: PropTypes.bool,
  progress: PropTypes.number,
}

export default injectIntl(LoaderScreen)
